import React, { useState } from 'react';

import { RideButton } from '@rimac-seguros/ride-system-components';

import ThankYouImage from '../../../../assets/ty-page/mujer-laptop-feliz-casa.png';
import ThankYouImageMb from '../../../../assets/ty-page/mujer-laptop-feliz-casa-mb.jpg';
import { tyPage as pageTexts } from '../../../../utils/texts';
import { getTagActionName } from '../../../../utils/analytics';
import { Layout, TyPageModalBody } from '../../../../components/organisms';
import { useAppContext } from '../../../../AppProvider';
import ModalPortal from '../../../../components/molecules/rbrModal/ModalPortal';
import RegisterAuditory from '../../../../auditory/component/RegisterAuditory';
import { AUDITORY_MODEL } from '../../../../models/step-thankyou';

const ThankYouPage = () => {
  const { pageTY } = pageTexts;
  const {
    state:
    {
      planSelected,
    },
  } = useAppContext();
  const [viewModal, setViewModal] = useState(false);

  const actionEvent = () => {
    getTagActionName('Seguro Salud Flexible', 'Interacciones', 'Click', 'Volver a página principal', 'trackAction');
    // navigate('/comprar/seguro-salud-flexible');
    window.location.href = '/comprar/seguro-salud-flexible';
  };

  const plan = pageTY.description.replace('[PLAN_SELECTED]', planSelected?.name);

  const handleOpenModal = () => {
    getTagActionName('Seguro Salud Flexible', 'Interacciones', 'Click', 'Conoce más', 'trackAction');
    setViewModal(!viewModal);
  };

  return (
    <Layout>
      <RegisterAuditory authoring={AUDITORY_MODEL} />
      <div className="ty-page">
        <div className="img-mobile-cont">
          <img className="img-mobile" src={ThankYouImageMb} alt="img-mobile" />
        </div>
        <div className="content-full ty-page">
          <div className="content-full__left">
            <img className="img-desktop" src={ThankYouImage} alt="img-desktop" />
          </div>
          <div className="content-full__right">
            <div className="typage-title">
              {pageTY.title}
            </div>
            <div className="typage-description" dangerouslySetInnerHTML={{ __html: plan }} />
            <div className="typage-keep">
              <div className="typage-keep_sub">
                {pageTY.keepSub}
              </div>
              <ul className="typage-keep_list">
                {
                  pageTY.keepList.map((item) => (
                    <li className="typage-keep_list-item">
                      {item.text}
                      {item.modalLink
                        && <span onClick={handleOpenModal}>Conoce más</span>}
                    </li>
                  ))
                }
              </ul>
            </div>
            <div className="typage-button">
              <RideButton
                text="Volver a la página principal"
                onClick={() => actionEvent()}
                size="x-large"
              />
            </div>
            <ModalPortal
              isOpen={viewModal}
              callbackClose={() => setViewModal(!viewModal)}
              extraClass="modal-pol-com modal-overflow-old"
            >
              <TyPageModalBody />
            </ModalPortal>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ThankYouPage;
